export class DashboardNotification {
  public message: any;
  public code: number;
  public data1: any;
  public data2: any;
  public  type: any;
}
